export default __webpack_public_path__ + "static/project-overview-back-c8b4824801d863e13b2f882614671396.webp";